module.exports = __webpack_public_path__ + "media/images/webpage/hotels/3105/facility-f3ef5c05e5a6a705fb907c89c037214f.webp";